export const UPLOADS_CHANGE = "UPLOADS_CHANGE";
export const REFRESH_JOBLIST = "REFRESH_JOBLIST";

const uploadFilesChangeAction = payload => (
    {
        type: UPLOADS_CHANGE,
        uploadFilesPayload: payload
    });

const refreshJobListAction = payload => (
    {
        type: REFRESH_JOBLIST,
        refreshJobListPayload: payload
    });

export { uploadFilesChangeAction, refreshJobListAction };
